import { Button } from '@lideralia/alife-uikit/dist/atoms/Button/Button';
import { Card } from '@lideralia/alife-uikit/dist/atoms/Card';
import { Icon } from '@lideralia/alife-uikit/dist/atoms/Icon';
import { IconCheck } from '@lideralia/alife-uikit/dist/atoms/Icons';
import IconHome from '@lideralia/alife-uikit/dist/atoms/Icons/IconHome';
import { Container, Flex } from '@lideralia/alife-uikit/dist/atoms/Layout';
import { Text } from '@lideralia/alife-uikit/dist/atoms/Typography/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CALL_TO_ACTION_TYPES } from '../../../../common/constants/callToActions';

export const ServiceOrderResumeTemplate = ({ goHome, order }) => (
  <Container paddingY={3} paddingBottom={8} maxWidth={['400px']}>
    <Flex alignItems="center" flexDirection="column" justifyContet="center" paddingBottom={6}>
      <Card padding="20px" style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
        <div
          style={{
            backgroundColor: '#A0B454',
            padding: '20px',
            width: '64px',
            height: '64px',
            borderRadius: '50px',
            margin: '0px auto 15px auto',
          }}
        >
          <Icon sizeIcon="display24" marginRight={2} color="white">
            <IconCheck />
          </Icon>
        </div>
        <Text
          as="h3"
          sizeText="display16"
          fontWeight="bold"
          textAlign="center"
          color="black84"
          marginBottom="10px"
        >
          {order?.orderable.call_to_action === CALL_TO_ACTION_TYPES.HIRE &&
          !order?.orderable.is_included ? (
            <FormattedMessage id="serviceProducts.thanksPurchase" />
          ) : (
            <FormattedMessage id="serviceProducts.orderRequestedTitle" />
          )}
        </Text>
        {order?.serviceSlug !== 'jewelry-store' && (
          <Text textAlign="center">
            <Text
              as="span"
              sizeText="display14"
              textAlign="center"
              marginTop="10px"
              color="black84"
            >
              <FormattedMessage id="serviceProducts.orderRequestedDescription" />{' '}
            </Text>
          </Text>
        )}
      </Card>

      <Button fullWidth action={goHome} marginTop="20px" backgroundColor="#black36">
        <Icon marginRight={2} sizeIcon="inherit" color="black84">
          <IconHome />
        </Icon>
        <FormattedMessage id="flowerEcommerce.backHome" />
      </Button>
    </Flex>
  </Container>
);

ServiceOrderResumeTemplate.defaultProps = {};
